import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../lib/medskin-data";

export const CTA = () => {
  return (
    <section id="book" className="py-24 md:py-32" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-[2rem] md:rounded-[2.5rem] overflow-hidden bg-[#4A4238]"
        >
          <div className="absolute inset-0 opacity-30">
            <img
              src={IMAGES.treatmentsAbstract}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#4A4238] via-[#4A4238]/90 to-[#4A4238]/60"></div>

          <div className="relative px-8 py-20 md:px-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-[#C4A981]"></span>
                <span className="text-[11px] uppercase tracking-[0.3em] text-[#D9D0C5]">Din hudreise</span>
              </div>
              <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-[#F7F6F3] leading-[1.05] tracking-tight font-light" data-testid="cta-headline">
                Start reisen mot sterkere og <em className="italic text-[#C4A981]">sunnere hud</em>.
              </h2>
              <p className="mt-6 max-w-xl text-base md:text-lg text-[#D9D0C5] font-light leading-relaxed">
                Book en personlig konsultasjon hos Medskinby – og opplev en helhetlig, faglig sterk tilnærming til huden din.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <a
                href="https://timma.no/salong/medskin-by"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-between gap-6 bg-[#F7F6F3] text-[#2C2C2A] hover:bg-[#C4A981] hover:text-[#F7F6F3] transition-all duration-500 rounded-full pl-7 pr-3 py-3 text-xs uppercase tracking-[0.22em]"
                data-testid="cta-book-btn"
              >
                Book time
                <span className="rounded-full bg-[#4A4238] text-[#F7F6F3] p-2.5 group-hover:rotate-45 transition-transform duration-500">
                  <ArrowUpRight size={14} strokeWidth={1.5} />
                </span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
